<div class="example-container mat-elevation-z8 table-container">
  @if (tableIsLoading$ | async) {
    <mat-progress-bar mode="indeterminate" style="width:100%"></mat-progress-bar>
  }
  <table [dataSource]="dataSource" mat-table matSort matSortActive="invoiceDate" matSortDirection="desc"
    matSortDisableClear style="width:100%">

    <ng-container matColumnDef="select">
      <th *matHeaderCellDef i18n mat-header-cell>Select</th>
      <td *matCellDef="let row" mat-cell>
        @if (displayAccountingCheckbox(row)) {
          <mat-checkbox (change)="toggleInvoiceSelection(row, $event)"
            [checked]="isInSelection(row)">
          </mat-checkbox>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="invoiceNr">
      <th *matHeaderCellDef i18n mat-header-cell mat-sort-header>Invoice Nr.</th>
      <td *matCellDef="let row" mat-cell>
        @if (row.invoiceNr2) {
          <span>{{ row.invoiceNr }}/{{ row.invoiceNr2 }}</span>
        }
        @if (!row.invoiceNr2) {
          <span>{{ row.invoiceNr }}</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="downloadUrl">
      <th *matHeaderCellDef i18n mat-header-cell>Document</th>
      <td *matCellDef="let row" mat-cell>
        @if (row.downloadUrl) {
          <span>
            <a [href]="row.downloadUrl" target="_blank">
              <mat-icon matListIcon>attach_file</mat-icon>
            </a>
          </span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="note">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Description</th>
      <td *matCellDef="let row" mat-cell> {{ row.note }}</td>
    </ng-container>

    <ng-container matColumnDef="vendor">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Vendor</th>
      <td *matCellDef="let row" mat-cell>
        <div> {{ row.order?.vendor?.name }}</div>
        @if (row.order.primaryContact?.emails) {
<a [href]="'https://mail.google.com/mail/u/0/?view=cm&fs=1&to='+ row.order.primaryContact.emails[0].email"
                   target="_blank">
          <span class="author-email">
            {{ row.order?.primaryContact?.name }}
          </span>
                    <span class="author-email">
            &#x3C;{{ row.order?.primaryContact?.emails[0].email }}&#x3E;
          </span>
                </a>
}
            </td>
        </ng-container>

        <ng-container matColumnDef="orderNr">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Order Nr.</th>
            <td *matCellDef="let row" mat-cell><a [routerLink]="['/order/view',row.order.id]"
                                                  target="_blank">{{ row.order.orderNr }}</a></td>
        </ng-container>

        <ng-container matColumnDef="invoiceDate">
            <th *matHeaderCellDef i18n mat-header-cell mat-sort-header>Invoice Date</th>
            <td *matCellDef="let row" mat-cell> {{ row.invoiceDate | date }}</td>
        </ng-container>

        <ng-container matColumnDef="amount">
            <th *matHeaderCellDef i18n mat-header-cell>Amount</th>
            <td *matCellDef="let row" mat-cell>@if (row.totalAmount) {
<span
                   > {{ row.totalAmount | currency:'EUR' }} </span>
}
            </td>
        </ng-container>

        <ng-container matColumnDef="sentToAccounting">
            <th *matHeaderCellDef i18n mat-header-cell>Sent To Accounting</th>
            <td *matCellDef="let row" mat-cell>
                @if (row.sentToAccounting) {
<mat-icon matListIcon>done</mat-icon>
}
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th *matHeaderCellDef i18n mat-header-cell>Actions</th>
            <td *matCellDef="let row" mat-cell>
                <a [routerLink]="['/invoices',row.id]" mat-icon-button>
                    @if (!row.sentToAccounting) {
<mat-icon>mode_edit</mat-icon>
}
                    @if (row.sentToAccounting) {
<mat-icon>visibility</mat-icon>
}
                </a>
            </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </table>

    <mat-paginator [length]="totalElements" [pageSizeOptions]="pageSizeOptions"></mat-paginator>
</div>